var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWindsock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128 96H64V32C64 14.326 49.674 0 32 0S0 14.326 0 32V496C0 504.836 7.164 512 16 512H48C56.836 512 64 504.836 64 496V320H128V364.799L208 348.799V67.199L128 51.199V96ZM128 272H64V144H128V272ZM272 336L368 316.799V99.199L272 80V336ZM492.707 124.141L432 112V303.998L492.707 291.857C503.926 289.615 512 279.764 512 268.324V147.676C512 136.234 503.926 126.385 492.707 124.141Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindsock);
export default __webpack_public_path__ + "static/media/windsock.c0818b2f0a8ac95cdebb5980a19a02e3.svg";
export { ForwardRef as ReactComponent };